<template>
  <BaseAction>
    <PrimaryButton @click.native="openCancelBookingDialog">
      Restore
      <v-icon size="20px" class="ml-1">
        mdi-undo
      </v-icon>
    </PrimaryButton>
    <RestoreUnitDialog
      v-if="isOpen"
      :isOpen="isOpen"
      :unit="unit"
      @update="$emit('update')"
      @close="closeCancelBookingDialog"
    />
  </BaseAction>
</template>

<script>
import BaseAction from "@/components/common/BaseAction";
import RestoreUnitDialog from "@/views/settings/Organisation/Units/dialogs/RestoreUnitDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  props: {
    unit: {
      type: Object,
      require: true
    }
  },
  components: {
    BaseAction,
    PrimaryButton,
    RestoreUnitDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openCancelBookingDialog() {
      this.isOpen = true;
    },
    closeCancelBookingDialog() {
      this.isOpen = false;
    }
  }
};
</script>
